module.exports = __webpack_public_path__ + "images/cm-hero-bg2-mobile.png";